// extracted by mini-css-extract-plugin
export var avatarContainer = "_fp-0";
export var gray = "_fp-f";
export var green = "_fp-c";
export var icon = "_fp-9";
export var image = "_fp-1";
export var lg = "_fp-6";
export var md = "_fp-5";
export var presenceDot = "_fp-b";
export var red = "_fp-d";
export var sm = "_fp-4";
export var status = "_fp-a";
export var xl = "_fp-7";
export var xs = "_fp-3";
export var xxl = "_fp-8";
export var xxs = "_fp-2";
export var yellow = "_fp-e";